import React, { useState, useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import Breadcrumb from './Breadcrumb';
import MobileMenu from './MobileMenu';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isDark, toggleTheme } = useTheme();

  // Prevent scrolling when modal is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Cleanup function to restore scrolling when component unmounts
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  return (
    <>
      <header className="flex shrink-0 items-center h-12 gap-2 border-b border-zinc-200 dark:border-zinc-800">
        <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
          <button
            className="block md:hidden inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50 size-7 -ml-1"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg fill="none" viewBox="0 0 16 16">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                d="M2 4.667V3.333A1.333 1.333 0 0 1 3.333 2h1.334m6.666 0h1.334A1.333 1.333 0 0 1 14 3.333v1.334m0 6.666v1.334A1.334 1.334 0 0 1 12.667 14h-1.334m-6.666 0H3.333A1.334 1.334 0 0 1 2 12.667v-1.334m3.333-6h5.334c.368 0 .666.299.666.667v4a.667.667 0 0 1-.666.667H5.333A.667.667 0 0 1 4.667 10V6c0-.368.298-.667.666-.667Z" />
            </svg>
            <span className="sr-only">Show Mobile Menu</span>
          </button>
          <Breadcrumb />
          <div className="ml-auto flex items-center gap-2">
            <button onClick={toggleTheme}>
              <div className="py-2 flex flex-col items-center justify-center gap-2">
                <div
                  className="hover:bg-zinc-200 dark:hover:bg-zinc-700 transition ease-in-out duration-250 flex items-center justify-center w-9 h-9 rounded-xl">
                  <span className="w-5 h-5 inline-block">
                    {isDark ? (
                      <svg fill="none" viewBox="0 0 20 20" className="w-5 h-5">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M10 2.5v.833m0 13.334v.833M2.5 10h.833m13.334 0h.833m-2.197-5.303-.589.589m-9.428 9.428-.59.59m0-10.607.59.589m9.428 9.428.59.59M13.333 10a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.666 0Z"/>
                      </svg>
                    ) : (
                      <svg fill="none" viewBox="0 0 20 20" className="w-5 h-5">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M10 2.5a5.303 5.303 0 0 0 7.5 7.5A7.5 7.5 0 1 1 10 2.5Z"/>
                      </svg>
                    )}
                  </span>
                </div>
              </div>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <MobileMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
    </>
  );
};

export default Header;
